import React, { useEffect } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import {
  Menu,
  MenuItem,
  IconButton,
  CssBaseline,
  AppBar,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  List,
  ListItem,
  ListItemText,
  Typography,
  ListItemIcon,
  Drawer
} from "@material-ui/core";
import {
  editProfile,
  addPasswordForm,
  getName,
  editUsersValidation,
  changePasswordValidation
} from "./SideBarConfig";
import { getProfileImageUrl } from "../../config";

import "./Sidebar.css";
import { MoreVert, Satellite } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import {
  routeConfig,
  routeAdmin,
  routeAdmin2,
  routeCustomer,
  routeCustomer2,
  routeCampaign,
  routeCampaign2,
  Routes
} from "./RouteContent";
import Logo from "../assets/logo.png";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  Link
} from "react-router-dom";
//import { fetchMethod } from "../FetchMethod";

import AttachFileIcon from "@material-ui/icons/AttachFile";
//import { API_URL } from "../Config";
import { changePassword } from "./SidebarQuery";
import ChangePassword from "../Form/EditForm";
import "../ChangePassword/changePassword.css";
import EditProfile from "../Form/EditForm";
import { updateUser } from "../Users/Userquery";
import "../Profile/editProfile.css";
import { fetchMethod } from "../../FetchMethod";
import Profile from "../assets/profile1.png";
import Password from "../assets/password1.png";
import Logout from "../assets/log_out.png";

import { FadeLoader } from "react-spinners";
function MiniDrawer(props) {
  const loggedInUserId = localStorage.getItem("id");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [Pdf, setPdf] = React.useState(null);
  const [openModal, setopenModal] = React.useState(false);
  const [selectPdf, setselectPdf] = React.useState(undefined);
  const [disableViewpdf, setdisableViewpdf] = React.useState(false);
  useEffect(() => {
    if (
      loggedInUserId !== undefined &&
      loggedInUserId !== null &&
      loggedInUserId !== ""
    ) {
      fetchMethod(getName(loggedInUserId))
        .then(res => res.json())
        .then(res => {
          if (
            res.data !== undefined &&
            res.data.allUsersdata !== undefined &&
            res.data.allUsersdata !== null &&
            res.data.allUsersdata.Usersdata.length > 0
          ) {
            setState({ ...state, name: res.data.allUsersdata.Usersdata[0] });
          }
        })
        .catch(e => {
          swal({ title: "Unable to reach server", icon: "warning" }).then(
            () => {
              localStorage.clear();
              window.location = "/";
            }
          );
        });
    }
  }, []);
  useEffect(() => {
    if (
      loggedInUserId === undefined ||
      loggedInUserId === null ||
      loggedInUserId === ""
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("email");
      // }
      // props.firstLetterNameText(state.name);
      // if (state.name === undefined && state.name === null && state.name === "") {
      //   localStorage.removeItem("token");
      //   localStorage.removeItem("id");
      //   localStorage.removeItem("email");
    }
  });
  const [state, setState] = React.useState({
    right1: false,
    right: false,
    showTab: false,
    status: "LIVE",
    name: [],
    getEditProfileData: [],
    loading: false,
    customerId: "",
    lastResponse: undefined
  });
  const [successMessage, setMessage] = React.useState({
    open: false,
    severity: "",
    alertmsg: "",
    loading: false,
    isFileUpload: false
  });
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isPdfOpen = Boolean(Pdf);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handlePdfClose = () => {
    setPdf(null);
  };
  /************************Timer for 25 minutes *****************************/

  //   useEffect(() => {

  //     window.onbeforeunload = confirmExit;
  //     function confirmExit()
  //     {
  //       if (window.performance.navigation.type !==window.performance.navigation.TYPE_RELOAD)
  //      localStorage.clear()
  //     }
  // }, [])
  const { initialMinute = 5, initialSeconds = 0 } = props;
  const [minutes, setMinutes] = React.useState(initialMinute);
  const [seconds, setSeconds] = React.useState(initialSeconds);
  // useEffect(() => {
  //   let myInterval = setInterval(() => {
  //     if (seconds > 0) {
  //       setSeconds(seconds - 1);
  //     }
  //     if (seconds === 0) {
  //       if (minutes === 0) {
  //         clearInterval(myInterval);
  //         // handleLogOut();
  //       } else {
  //         setMinutes(minutes - 1);
  //         setSeconds(59);
  //       }
  //     }
  //   }, 1000);
  //   return () => {
  //     clearInterval(myInterval);
  //   };
  // });

  let timer = 0;
  const secondsToTime = secs => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    minutes = ("0" + minutes).slice(-2);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    seconds = ("0" + seconds).slice(-2);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds
    };
    return obj;
  };

  // Check if we're at zero.

  const handleClose = () => {};

  /*************************************************************/
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const toggleDrawer = (side, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [side]: open });
    setAnchorEl(null);
  };

  // const handleLogOut = () => {};
  const handleLogOut = () => {
    swal({
      title: "Are you sure you want to logout?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete)
        return (
          localStorage.removeItem("token"),
          localStorage.removeItem("id"),
          localStorage.removeItem("userId"),
          localStorage.removeItem("role"),
          localStorage.removeItem("customer"),
          localStorage.removeItem("email"),
          localStorage.removeItem("name"),
          localStorage.removeItem("profileImage"),
          (window.location = "/")
        );
    });
  };
  // const handleProfile = () => {

  //   if (
  //     loggedInUserId !== undefined &&
  //     loggedInUserId !== null &&
  //     loggedInUserId !== ""
  //   ) {
  //     fetchMethod(getName(loggedInUserId))
  //       .then(res => res.json())
  //       .then(res => {

  //         if (
  //           res.data !== undefined &&
  //           res.data.allUsersdata !== undefined &&
  //           res.data.allUsersdata !== null &&
  //           res.data.allUsersdata.Usersdata.length > 0
  //         ) {
  //           setState({ ...state, name: res.data.allUsersdata.Usersdata[0] });
  //         }
  //       })
  //       .then(data => {
  //         toggleDrawer("right", true);
  //       })
  //       .catch(e => {
  //         swal({ title: "Unable to reach server", icon: "warning" }).then(
  //           () => {
  //             localStorage.clear();
  //             window.location = "/";
  //           }
  //         );
  //       });
  //   }
  // };

  const firstName =
    props.userName.firstName !== null && props.userName.firstName !== undefined
      ? props.userName.firstName
      : "";
  const lastName =
    props.userName.lastName !== null && props.userName.lastName !== undefined
      ? props.userName.lastName
      : "";
  let a = "";
  let b = "";
  let firstname = "";
  let lastname = "";
  if (
    firstName !== undefined &&
    lastName !== undefined &&
    firstName !== null &&
    lastName !== null
  ) {
    firstname = firstName.split(/\s/).slice(0, 1);
    lastname = lastName.split(/\s/).slice(0, 1);
    a = firstName === "" ? "" : firstName.charAt(0);
    b = lastName === "" ? "" : lastName.charAt(0);
  }

  const menuId = "primary-search-account-menu";
  const handlePdf = event => {
    setPdf(event.currentTarget);
  };

  const ModifyPdf = () => {
    setopenModal(true);
    setPdf(null);
  };
  const handleClosePdf = () => {
    setopenModal(false);
    setselectPdf(undefined);
  };
  const clearPdf = () => {
    setselectPdf(undefined);
  };
  const uploadPdf = () => {};

  const onDrop = acceptedFile => {
    setselectPdf(acceptedFile[0]);
  };
  const viewPdf = () => {};
  const renderPdf = (
    <div>
      <Menu
        anchorEl={Pdf}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isPdfOpen}
        onClose={handlePdfClose}
      >
        <MenuItem onClick={viewPdf} disabled={disableViewpdf}>
          View
        </MenuItem>
        <MenuItem onClick={ModifyPdf}>Modify</MenuItem>
      </Menu>
    </div>
  );
  const renderMenu = (
    <div>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem
          style={{ fontSize: "12px" }}
          onClick={(handleMenuClose, toggleDrawer("right", true))}
        >
          Profile
          <img
            src={Profile}
            alt="Delete"
            className="deleteButton"
            title="Profile"
          />
        </MenuItem>

        <MenuItem
          style={{ fontSize: "12px" }}
          onClick={(handleMenuClose, toggleDrawer("right1", true))}
        >
          Password
          <img
            src={Password}
            alt="Delete"
            className="deleteButton"
            title="Password"
          />
        </MenuItem>
        <MenuItem onClick={(handleMenuClose, handleLogOut)}>
          Sign Out{" "}
          <img
            src={Logout}
            alt="Delete"
            className="deleteButton"
            title="Sign Out"
          />
        </MenuItem>
      </Menu>
    </div>
  );
  const footerStyle = {
    padding: "10px 0px",
    textAlign: "center"
  };
  return (
    <Router>
      {loading ? (
        <div className="Loader">
          <FadeLoader
            style={{ height: "15", width: "5", radius: "2" }}
            color={"#6FABF0"}
            loading={loading}
          />
        </div>
      ) : (
        ""
      )}

      <Dialog
        className="LogoutMessageSession"
        open={props.showModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography> Session Timeout</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your online session will expire in
          </DialogContentText>
          {minutes === 0 && seconds === 0 ? null : (
            <h2 className="timerwindow">
              {" "}
              {minutes < 10 ? `0${minutes}` : minutes} min{" "}
              {seconds < 10 ? `0${seconds}` : seconds} secs
            </h2>
          )}
          <p>
            <span>Please click "Continue" to Keep working</span>
            <span>or click "Log Off" to end your sesion now.</span>
          </p>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} className="cancelbtn">
            Continue
          </Button>
          {/* <Button onClick={handleLogOut} autoFocus className="confirmbtn">
            Log Off
          </Button> */}
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModal}
        onClose={handleClosePdf}
        aria-labelledby="simple-modal-title"
        ariadescribedby="simple-modal-description"
      >
        <div className="IFUPdfDialog">
          <div>
            <div className="employeeexcelHeader">
              <h5> Upload IFU PDF</h5>
              <span onClick={handleClosePdf}>
                <CloseIcon />
              </span>
            </div>

            <p>Choose a file to upload.</p>
          </div>
          <ul>
            <li>
              <form>
                <input
                  style={{ display: "none" }}
                  accept=".pdf"
                  id="contained-button-file"
                  type="file"
                  onChange={e => onDrop(e.target.files)}
                  onClick={e => (e.target.value = null)}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="outlined"
                    color="primary"
                    className="btnDvrStatusReport"
                    component="span"
                    startIcon={<AttachFileIcon />}
                  >
                    Browse
                  </Button>
                </label>
              </form>
            </li>
            <li>
              <p>
                <span>{selectPdf ? selectPdf.name : "Browse File"}</span>
                <span>
                  {selectPdf ? (
                    <CloseIcon
                      onClick={clearPdf}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    ""
                  )}
                </span>
              </p>
            </li>
            <li>
              {selectPdf ? (
                <Button onClick={uploadPdf}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.0"
                    width="10.000000pt"
                    height="10.000000pt"
                    viewBox="0 0 225.000000 225.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
                      fill="#000000"
                      stroke="none"
                    >
                      <path d="M1085 2240 c-19 -6 -139 -119 -337 -317 -330 -330 -338 -340 -318 -414 5 -19 24 -48 41 -65 27 -26 37 -29 95 -29 l64 0 172 173 c95 94 177 172 181 172 4 0 7 -250 7 -555 l0 -554 31 -36 c59 -66 150 -66 208 1 l31 35 0 554 c0 305 3 555 7 555 4 0 86 -78 181 -172 l172 -173 64 0 c58 0 68 3 96 30 38 36 53 88 40 135 -7 27 -83 108 -323 348 -172 171 -319 312 -327 312 -8 0 -24 2 -35 5 -11 2 -33 0 -50 -5z" />
                      <path d="M84 831 c-35 -15 -72 -69 -79 -114 -4 -23 -5 -171 -3 -329 3 -271 4 -288 24 -314 11 -15 33 -37 48 -48 27 -21 33 -21 1051 -21 1018 0 1024 0 1051 21 15 11 37 33 48 48 20 26 21 43 24 326 2 185 -1 313 -7 337 -6 22 -25 52 -41 68 -28 27 -38 30 -96 30 -61 0 -68 -2 -94 -32 -43 -48 -50 -90 -50 -310 l0 -203 -835 0 -835 0 0 203 c0 219 -7 262 -49 309 -23 26 -36 32 -82 34 -30 2 -63 0 -75 -5z" />
                    </g>
                  </svg>{" "}
                  Upload
                </Button>
              ) : (
                ""
              )}
            </li>
          </ul>
          <p style={{ textAlign: "center", marginTop: "5px", color: "red" }}>
            {error}
          </p>
        </div>
      </Dialog>
      <div>
        <CssBaseline />
        <AppBar position="fixed">
          <div className="logo">
            <img src={Logo} className="logo" alt="Surveillance" />
            {/* <h2>
              <span>Uptake</span>Medical<sup>R</sup>
            </h2>
            <span>A Broncus Company</span> */}
          </div>
          <div className="headerFields">
            <List className="lists">
              {localStorage.getItem("role") === "SADMIN"
                ? routeConfig.map((items, index) => (
                    <div key={index}>
                      {
                        <div
                          key={index}
                          className={
                            props.sidebarRoute === items.path
                              ? "sidebarColor menuItem"
                              : "menuItem"
                          }
                        >
                          <span key={index}>
                            <ListItem
                              button
                              key={items.title}
                              component={Link}
                              className={
                                localStorage.getItem("path") == items.path
                                  ? "activeLink"
                                  : ""
                              }
                              onClick={e => {
                                setSelectedIndex(items.path);
                                if (
                                  localStorage.getItem("path") !== items.path
                                ) {
                                  localStorage.setItem("path", items.path);
                                  localStorage.setItem("rows", 10);
                                }
                              }}
                              to={`${items.path}`}
                            >
                              <ListItemText primary={items.title} />
                            </ListItem>
                          </span>
                        </div>
                      }
                    </div>
                  ))
                : localStorage.getItem("role") === "CUSTOMER" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                ? routeCustomer.map((items, index) => (
                    <div key={index}>
                      {
                        <div
                          key={index}
                          className={
                            props.sidebarRoute === items.path
                              ? "sidebarColor menuItem"
                              : "menuItem"
                          }
                        >
                          <span key={index}>
                            <ListItem
                              button
                              key={items.title}
                              component={Link}
                              className={
                                localStorage.getItem("path") == items.path
                                  ? "activeLink"
                                  : ""
                              }
                              onClick={e => {
                                setSelectedIndex(items.path);
                                if (
                                  localStorage.getItem("path") !== items.path
                                ) {
                                  localStorage.setItem("path", items.path);
                                  localStorage.setItem("rows", 10);
                                }
                              }}
                              to={`${items.path}`}
                            >
                              <ListItemText primary={items.title} />
                            </ListItem>
                          </span>
                        </div>
                      }
                    </div>
                  ))
                  : localStorage.getItem("role") === "CUSTOMER" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                  ? routeCustomer2.map((items, index) => (
                      <div key={index}>
                        {
                          <div
                            key={index}
                            className={
                              props.sidebarRoute === items.path
                                ? "sidebarColor menuItem"
                                : "menuItem"
                            }
                          >
                            <span key={index}>
                              <ListItem
                                button
                                key={items.title}
                                component={Link}
                                className={
                                  localStorage.getItem("path") == items.path
                                    ? "activeLink"
                                    : ""
                                }
                                onClick={e => {
                                  setSelectedIndex(items.path);
                                  if (
                                    localStorage.getItem("path") !== items.path
                                  ) {
                                    localStorage.setItem("path", items.path);
                                    localStorage.setItem("rows", 10);
                                  }
                                }}
                                to={`${items.path}`}
                              >
                                <ListItemText primary={items.title} />
                              </ListItem>
                            </span>
                          </div>
                        }
                      </div>
                    ))
                : localStorage.getItem("role") === "CAMPAIGNMANAGER" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                ? routeCampaign.map((items, index) => (
                    <div key={index}>
                      {
                        <div
                          key={index}
                          className={
                            props.sidebarRoute === items.path
                              ? "sidebarColor menuItem"
                              : "menuItem"
                          }
                        >
                          <span key={index}>
                            <ListItem
                              button
                              key={items.title}
                              component={Link}
                              className={
                                localStorage.getItem("path") == items.path
                                  ? "activeLink"
                                  : ""
                              }
                              onClick={e => {
                                setSelectedIndex(items.path);
                                if (
                                  localStorage.getItem("path") !== items.path
                                ) {
                                  localStorage.setItem("path", items.path);
                                  localStorage.setItem("rows", 10);
                                }
                              }}
                              to={`${items.path}`}
                            >
                              <ListItemText primary={items.title} />
                            </ListItem>
                          </span>
                        </div>
                      }
                    </div>
                  ))
                  : localStorage.getItem("role") === "CAMPAIGNMANAGER" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                  ? routeCampaign2.map((items, index) => (
                      <div key={index}>
                        {
                          <div
                            key={index}
                            className={
                              props.sidebarRoute === items.path
                                ? "sidebarColor menuItem"
                                : "menuItem"
                            }
                          >
                            <span key={index}>
                              <ListItem
                                button
                                key={items.title}
                                component={Link}
                                className={
                                  localStorage.getItem("path") == items.path
                                    ? "activeLink"
                                    : ""
                                }
                                onClick={e => {
                                  setSelectedIndex(items.path);
                                  if (
                                    localStorage.getItem("path") !== items.path
                                  ) {
                                    localStorage.setItem("path", items.path);
                                    localStorage.setItem("rows", 10);
                                  }
                                }}
                                to={`${items.path}`}
                              >
                                <ListItemText primary={items.title} />
                              </ListItem>
                            </span>
                          </div>
                        }
                      </div>
                    ))
                : localStorage.getItem("role") === "ADMIN" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                ? routeAdmin.map((items, index) => (
                    <div key={index}>
                      {
                        <div
                          key={index}
                          className={
                            props.sidebarRoute === items.path
                              ? "sidebarColor menuItem"
                              : "menuItem"
                          }
                        >
                          <span key={index}>
                            <ListItem
                              button
                              key={items.title}
                              component={Link}
                              className={
                                localStorage.getItem("path") == items.path
                                  ? "activeLink"
                                  : ""
                              }
                              onClick={e => {
                                setSelectedIndex(items.path);
                                if (
                                  localStorage.getItem("path") !== items.path
                                ) {
                                  localStorage.setItem("path", items.path);
                                  localStorage.setItem("rows", 10);
                                }
                              }}
                              to={`${items.path}`}
                            >
                              <ListItemText primary={items.title} />
                            </ListItem>
                          </span>
                        </div>
                      }
                    </div>
                  ))
                  : localStorage.getItem("role") === "ADMIN" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                  ? routeAdmin2.map((items, index) => (
                      <div key={index}>
                        {
                          <div
                            key={index}
                            className={
                              props.sidebarRoute === items.path
                                ? "sidebarColor menuItem"
                                : "menuItem"
                            }
                          >
                            <span key={index}>
                              <ListItem
                                button
                                key={items.title}
                                component={Link}
                                className={
                                  localStorage.getItem("path") == items.path
                                    ? "activeLink"
                                    : ""
                                }
                                onClick={e => {
                                  setSelectedIndex(items.path);
                                  if (
                                    localStorage.getItem("path") !== items.path
                                  ) {
                                    localStorage.setItem("path", items.path);
                                    localStorage.setItem("rows", 10);
                                  }
                                }}
                                to={`${items.path}`}
                              >
                                <ListItemText primary={items.title} />
                              </ListItem>
                            </span>
                          </div>
                        }
                      </div>
                    ))
                : ""}
            </List>
            <ul>
            {/* <li><div className="profileSection">
              <div className="profilepart">
                { <Avatar>{localStorage.getItem("userInitials")}</Avatar> }
                { <span>{localStorage.getItem("name")}</span> }

                { <span>{localStorage.getItem("name").substring(0, 1)}</span> }
              </div>
            </div> </li>*/}
            <li>
              <div className="moreVertIconAndAvatar">
                <IconButton
                  //   edge="end"

                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  style={{ color: "#004a87" }}
                >
                  {localStorage.getItem("profileImage") != "null" && (
                    <img
                      style={{ width: "26px", borderRadius: "50%" }}
                      src={
                        getProfileImageUrl.url +
                        localStorage.getItem("profileImage")
                      }
                    />
                  )}
                  {localStorage.getItem("profileImage") == "null" && (
                    <div> {localStorage.getItem("name").substring(0, 1)} </div>
                  )}

                  {/* <MoreVert /> */}
                </IconButton>
              </div>
              {renderMenu}
              {renderPdf}
            </li>
            <li class="sideBarMenu" id="sideBarMenu">
              <button><span></span></button>
            </li>
            </ul>
          </div>
        </AppBar>
        {/*****************Footer for Sidebar******************* */}
        {/***********************End**************************** */}
        <div className="mainSectionBox">
          {/* <div className={classes.toolbar} /> */}
          <div className="mainSection">
            {/* <Switch>
              {routeConfig.map(
                (route, index) => (
                 
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={route.main}
                  />
                )
               
              )}
              <Redirect to="/"></Redirect>
            </Switch> */}
            <Switch>
              {localStorage.getItem("role") === "ADMIN" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                ? routeAdmin.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.main}
                    />
                  ))
                  : localStorage.getItem("role") === "ADMIN" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                  ? routeAdmin2.map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.main}
                      />
                    ))
                : localStorage.getItem("role") === "CUSTOMER" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                ? routeCustomer.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.main}
                    />
                  ))
                  : localStorage.getItem("role") === "CUSTOMER" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                  ? routeCustomer2.map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.main}
                      />
                    ))
                : localStorage.getItem("role") === "SADMIN"
                ? routeConfig.map((route, index) => (
                    // <Route
                    //   key={index}
                    //   path={route.path}
                    //   exact={route.exact}
                    //   // component={subitem.main}
                    //   render={e => route.main(e, props)}
                    // />
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.main}
                    />
                  ))
                : localStorage.getItem("role") === "CAMPAIGNMANAGER" && localStorage.getItem("abmId") === localStorage.getItem("id")+1
                ? routeCampaign2.map((route, index) => (
                 
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.main}
                    />
                  ))
                  : localStorage.getItem("role") === "CAMPAIGNMANAGER" && localStorage.getItem("abmId") !== localStorage.getItem("id")+1
                  ? routeCampaign.map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.main}
                      />
                    ))
                : ""}
            </Switch>
          </div>
          <footer style={footerStyle}>
            <div className="footerBox">
              <h5>&copy; Xseller, 2026. All right reserved</h5>
            </div>
          </footer>
        </div>
        <div>
          <Drawer anchor="right" open={state.right1}>
            <ChangePassword
              query={changePassword}
              title="Change Password"
              formConfig={addPasswordForm}
              modalClose={toggleDrawer("right1", false)}
              className={"ChangePassword"}
              buttonName={"Update"}
              message="Password updated successfully"
              formValidation={changePasswordValidation}
            />
          </Drawer>
        </div>
        <div>
          <Drawer anchor="right" open={state.right}>
            <EditProfile
              title="Edit Profile"
              formConfig={editProfile}
              modalClose={toggleDrawer("right", false)}
              className={"EditProfile"}
              editableData={state.name}
              query={updateUser}
              formValidation={editUsersValidation}
              message="Profile updated successfully"
              buttonName={"Update"}
            />
          </Drawer>
        </div>
      </div>
    </Router>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    showDialogbox: data => dispatch({ type: "ShowModal", showModal: data }),
    TimeDelay: data => dispatch({ type: "TimeDelay", seconds: data })
  };
};

// const mapStateToProps = state => {
//   return {
//     Header: state.Header,
//     sidebarRoute: state.sidebarRoute,
//     showModal: state.showModal,
//     seconds: state.seconds,
//     role: state.role
//   };
// };

const mapStateToProps = state => {
  return {
    Header: state.Header,
    userName: state.userName
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniDrawer);




// import React, { useEffect } from "react";
// import { connect } from "react-redux";
// import swal from "sweetalert";
// import {
//   Menu,
//   MenuItem,
//   IconButton,
//   CssBaseline,
//   AppBar,
//   //Avatar,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   DialogContentText,
//   List,
//   ListItem,
//   ListItemText,
//   Typography,
//   //ListItemIcon,
//   Drawer
// } from "@material-ui/core";
// import {
//   editProfile,
//   addPasswordForm,
//   getName,
//   editUsersValidation,
//   changePasswordValidation
// } from "./SideBarConfig";
// import { getProfileImageUrl } from "../../config";

// import "./Sidebar.css";
// //import { MoreVert, Satellite } from "@material-ui/icons";
// import CloseIcon from "@material-ui/icons/Close";
// import {
//   routeConfig,
//   routeAdmin,
//   routeCustomer,
//   routeCampaign,
//  // Routes
// } from "./RouteContent";
// import Logo from "../assets/logo.png";
// import {
//   BrowserRouter as Router,
//  // Redirect,
//   Route,
//   Switch,
//   Link
// } from "react-router-dom";
// import AttachFileIcon from "@material-ui/icons/AttachFile";
// import { changePassword } from "./SidebarQuery";
// import ChangePassword from "../Form/EditForm";
// import "../ChangePassword/changePassword.css";
// import EditProfile from "../Form/EditForm";
// import { updateUser } from "../Users/Userquery";
// import "../Profile/editProfile.css";
// import { fetchMethod } from "../../FetchMethod";
// import Profile from "../assets/profile1.png";
// import Password from "../assets/password1.png";
// import Logout from "../assets/log_out.png";

// import { FadeLoader } from "react-spinners";
// function MiniDrawer(props) {
//   const loggedInUserId = localStorage.getItem("id");

//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [Pdf, setPdf] = React.useState(null);
//   const [openModal, setopenModal] = React.useState(false);
//   const [selectPdf, setselectPdf] = React.useState(undefined);
//   const [disableViewpdf] = React.useState(false);
//   useEffect(() => {
//     if (
//       loggedInUserId !== undefined &&
//       loggedInUserId !== null &&
//       loggedInUserId !== ""
//     ) {
//       fetchMethod(getName(loggedInUserId))
//         .then(res => res.json())
//         .then(res => {
//           if (
//             res.data !== undefined &&
//             res.data.allUsersdata !== undefined &&
//             res.data.allUsersdata !== null &&
//             res.data.allUsersdata.Usersdata.length > 0
//           ) {
//             setState({ ...state, name: res.data.allUsersdata.Usersdata[0] });
//           }
//         })
//         .catch(e => {
//           swal({ title: "Unable to reach server", icon: "warning" }).then(
//             () => {
//               localStorage.clear();
//               window.location = "/";
//             }
//           );
//         });
//     }
//   }, []);
//   useEffect(() => {
//     if (
//       loggedInUserId === undefined ||
//       loggedInUserId === null ||
//       loggedInUserId === ""
//     ) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("id");
//       localStorage.removeItem("email");
 
//     }
//   });
//   const [state, setState] = React.useState({
//     right1: false,
//     right: false,
//     showTab: false,
//     status: "LIVE",
//     name: [],
//     getEditProfileData: [],
//     loading: false,
//     customerId: "",
//     lastResponse: undefined
//   });
//   // const [successMessage, setMessage] = React.useState({
//   //   open: false,
//   //   severity: "",
//   //   alertmsg: "",
//   //   loading: false,
//   //   isFileUpload: false
//   // });
//   const [error, setError] = React.useState("");
//   const [loading, setLoading] = React.useState(false);
//   const isMenuOpen = Boolean(anchorEl);
//   const isPdfOpen = Boolean(Pdf);

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };
//   const handlePdfClose = () => {
//     setPdf(null);
//   };
//   /************************Timer for 25 minutes *****************************/

//   const { initialMinute = 5, initialSeconds = 0 } = props;
//   const [minutes, setMinutes] = React.useState(initialMinute);
//   const [seconds, setSeconds] = React.useState(initialSeconds);


//   let timer = 0;
//   const secondsToTime = secs => {
//     let hours = Math.floor(secs / (60 * 60));

//     let divisor_for_minutes = secs % (60 * 60);
//     let minutes = Math.floor(divisor_for_minutes / 60);
//     minutes = ("0" + minutes).slice(-2);
//     let divisor_for_seconds = divisor_for_minutes % 60;
//     let seconds = Math.ceil(divisor_for_seconds);
//     seconds = ("0" + seconds).slice(-2);

//     let obj = {
//       h: hours,
//       m: minutes,
//       s: seconds
//     };
//     return obj;
//   };

//   // Check if we're at zero.

//   const handleClose = () => {};

//   /*************************************************************/
//   const [selectedIndex, setSelectedIndex] = React.useState(0);

//   const handleProfileMenuOpen = event => {
//     setAnchorEl(event.currentTarget);
//   };

//   const toggleDrawer = (side, open) => event => {
//     if (
//       event &&
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }
//     setState({ ...state, [side]: open });
//     setAnchorEl(null);
//   };

//   const handleLogOut = () => {
//     swal({
//       title: "Are you sure you want to logout?",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true
//     }).then(willDelete => {
//       if (willDelete)
//         return (
//           localStorage.removeItem("token"),
//           localStorage.removeItem("id"),
//           localStorage.removeItem("userId"),
//           localStorage.removeItem("role"),
//           localStorage.removeItem("customer"),
//           localStorage.removeItem("email"),
//           localStorage.removeItem("name"),
//           localStorage.removeItem("profileImage"),
//           (window.location = "/")
//         );
//     });
//   };


//   // const firstName =
//   //   props.userName.firstName !== null && props.userName.firstName !== undefined
//   //     ? props.userName.firstName
//   //     : "";
//   // const lastName =
//   //   props.userName.lastName !== null && props.userName.lastName !== undefined
//   //     ? props.userName.lastName
//   //     : "";
//   // let a = "";
//   // let b = "";
//   // let firstname = "";
//   // let lastname = "";
//   // if (
//   //   firstName !== undefined &&
//   //   lastName !== undefined &&
//   //   firstName !== null &&
//   //   lastName !== null
//   // ) {
//   //   firstname = firstName.split(/\s/).slice(0, 1);
//   //   lastname = lastName.split(/\s/).slice(0, 1);
//   //   a = firstName === "" ? "" : firstName.charAt(0);
//   //   b = lastName === "" ? "" : lastName.charAt(0);
//   // }

//   const menuId = "primary-search-account-menu";
//   // const handlePdf = event => {
//   //   setPdf(event.currentTarget);
//   // };

//   const ModifyPdf = () => {
//     setopenModal(true);
//     setPdf(null);
//   };
//   const handleClosePdf = () => {
//     setopenModal(false);
//     setselectPdf(undefined);
//   };
//   const clearPdf = () => {
//     setselectPdf(undefined);
//   };
//   const uploadPdf = () => {};

//   const onDrop = acceptedFile => {
//     setselectPdf(acceptedFile[0]);
//   };
//   const viewPdf = () => {};
//   const renderPdf = (
//     <div>
//       <Menu
//         anchorEl={Pdf}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         id={menuId}
//         keepMounted
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//         open={isPdfOpen}
//         onClose={handlePdfClose}
//       >
//         <MenuItem onClick={viewPdf} disabled={disableViewpdf}>
//           View
//         </MenuItem>
//         <MenuItem onClick={ModifyPdf}>Modify</MenuItem>
//       </Menu>
//     </div>
//   );
//   const renderMenu = (
//     <div>
//       <Menu
//         anchorEl={anchorEl}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         id={menuId}
//         keepMounted
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//         open={isMenuOpen}
//         onClose={handleMenuClose}
//       >
//         <MenuItem
//           style={{ fontSize: "12px" }}
//           onClick={(handleMenuClose, toggleDrawer("right", true))}
//         >
//           Profile
//           <img
//             src={Profile}
//             alt="Delete"
//             className="deleteButton"
//             title="Profile"
//           />
//         </MenuItem>

//         <MenuItem
//           style={{ fontSize: "12px" }}
//           onClick={(handleMenuClose, toggleDrawer("right1", true))}
//         >
//           Password
//           <img
//             src={Password}
//             alt="Delete"
//             className="deleteButton"
//             title="Password"
//           />
//         </MenuItem>
//         <MenuItem onClick={(handleMenuClose, handleLogOut)}>
//           Sign Out{" "}
//           <img
//             src={Logout}
//             alt="Delete"
//             className="deleteButton"
//             title="Sign Out"
//           />
//         </MenuItem>
//       </Menu>
//     </div>
//   );
//   const footerStyle = {
//     padding: "10px 0px",
//     textAlign: "center"
//   };
//   return (
//     <Router>
//       {loading ? (
//         <div className="Loader">
//           <FadeLoader
//             style={{ height: "15", width: "5", radius: "2" }}
//             color={"#6FABF0"}
//             loading={loading}
//           />
//         </div>
//       ) : (
//         ""
//       )}

//       <Dialog
//         className="LogoutMessageSession"
//         open={props.showModal}
//         onClose={handleClose}
//         aria-labelledby="responsive-dialog-title"
//       >
//         <DialogTitle id="responsive-dialog-title">
//           <Typography> Session Timeout</Typography>
//           <IconButton onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Your online session will expire in
//           </DialogContentText>
//           {minutes === 0 && seconds === 0 ? null : (
//             <h2 className="timerwindow">
//               {" "}
//               {minutes < 10 ? `0${minutes}` : minutes} min{" "}
//               {seconds < 10 ? `0${seconds}` : seconds} secs
//             </h2>
//           )}
//           <p>
//             <span>Please click "Continue" to Keep working</span>
//             <span>or click "Log Off" to end your sesion now.</span>
//           </p>
//         </DialogContent>
//         <DialogActions>
//           <Button autoFocus onClick={handleClose} className="cancelbtn">
//             Continue
//           </Button>
         
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={openModal}
//         onClose={handleClosePdf}
//         aria-labelledby="simple-modal-title"
//         ariadescribedby="simple-modal-description"
//       >
//         <div className="IFUPdfDialog">
//           <div>
//             <div className="employeeexcelHeader">
//               <h5> Upload IFU PDF</h5>
//               <span onClick={handleClosePdf}>
//                 <CloseIcon />
//               </span>
//             </div>

//             <p>Choose a file to upload.</p>
//           </div>
//           <ul>
//             <li>
//               <form>
//                 <input
//                   style={{ display: "none" }}
//                   accept=".pdf"
//                   id="contained-button-file"
//                   type="file"
//                   onChange={e => onDrop(e.target.files)}
//                   onClick={e => (e.target.value = null)}
//                 />
//                 <label htmlFor="contained-button-file">
//                   <Button
//                     variant="outlined"
//                     color="primary"
//                     className="btnDvrStatusReport"
//                     component="span"
//                     startIcon={<AttachFileIcon />}
//                   >
//                     Browse
//                   </Button>
//                 </label>
//               </form>
//             </li>
//             <li>
//               <p>
//                 <span>{selectPdf ? selectPdf.name : "Browse File"}</span>
//                 <span>
//                   {selectPdf ? (
//                     <CloseIcon
//                       onClick={clearPdf}
//                       style={{ cursor: "pointer" }}
//                     />
//                   ) : (
//                     ""
//                   )}
//                 </span>
//               </p>
//             </li>
//             <li>
//               {selectPdf ? (
//                 <Button onClick={uploadPdf}>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     version="1.0"
//                     width="10.000000pt"
//                     height="10.000000pt"
//                     viewBox="0 0 225.000000 225.000000"
//                     preserveAspectRatio="xMidYMid meet"
//                   >
//                     <g
//                       transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
//                       fill="#000000"
//                       stroke="none"
//                     >
//                       <path d="M1085 2240 c-19 -6 -139 -119 -337 -317 -330 -330 -338 -340 -318 -414 5 -19 24 -48 41 -65 27 -26 37 -29 95 -29 l64 0 172 173 c95 94 177 172 181 172 4 0 7 -250 7 -555 l0 -554 31 -36 c59 -66 150 -66 208 1 l31 35 0 554 c0 305 3 555 7 555 4 0 86 -78 181 -172 l172 -173 64 0 c58 0 68 3 96 30 38 36 53 88 40 135 -7 27 -83 108 -323 348 -172 171 -319 312 -327 312 -8 0 -24 2 -35 5 -11 2 -33 0 -50 -5z" />
//                       <path d="M84 831 c-35 -15 -72 -69 -79 -114 -4 -23 -5 -171 -3 -329 3 -271 4 -288 24 -314 11 -15 33 -37 48 -48 27 -21 33 -21 1051 -21 1018 0 1024 0 1051 21 15 11 37 33 48 48 20 26 21 43 24 326 2 185 -1 313 -7 337 -6 22 -25 52 -41 68 -28 27 -38 30 -96 30 -61 0 -68 -2 -94 -32 -43 -48 -50 -90 -50 -310 l0 -203 -835 0 -835 0 0 203 c0 219 -7 262 -49 309 -23 26 -36 32 -82 34 -30 2 -63 0 -75 -5z" />
//                     </g>
//                   </svg>{" "}
//                   Upload
//                 </Button>
//               ) : (
//                 ""
//               )}
//             </li>
//           </ul>
//           <p style={{ textAlign: "center", marginTop: "5px", color: "red" }}>
//             {error}
//           </p>
//         </div>
//       </Dialog>
//       <div>
//         <CssBaseline />
//         <AppBar position="fixed">
//           <div className="logo">
//             <img src={Logo} className="logo" alt="Surveillance" />
           
//           </div>
//           <div className="headerFields">
//             <List className="lists">
//               {localStorage.getItem("role") === "SADMIN"
//                 ? routeConfig.map((items, index) => (
//                     <div key={index}>
//                       {
//                         <div
//                           key={index}
//                           className={
//                             props.sidebarRoute === items.path
//                               ? "sidebarColor menuItem"
//                               : "menuItem"
//                           }
//                         >
//                           <span key={index}>
//                             <ListItem
//                               button
//                               key={items.title}
//                               component={Link}
//                               className={
//                                 localStorage.getItem("path") === items.path
//                                   ? "activeLink"
//                                   : ""
//                               }
//                               onClick={e => {
//                                 setSelectedIndex(items.path);
//                                 if (
//                                   localStorage.getItem("path") !== items.path
//                                 ) {
//                                   localStorage.setItem("path", items.path);
//                                   localStorage.setItem("rows", 10);
//                                 }
//                               }}
//                               to={`${items.path}`}
//                             >
//                               <ListItemText primary={items.title} />
//                             </ListItem>
//                           </span>
//                         </div>
//                       }
//                     </div>
//                   ))
//                 : localStorage.getItem("role") === "CUSTOMER"
//                 ? routeCustomer.map((items, index) => (
//                     <div key={index}>
//                       {
//                         <div
//                           key={index}
//                           className={
//                             props.sidebarRoute === items.path
//                               ? "sidebarColor menuItem"
//                               : "menuItem"
//                           }
//                         >
//                           <span key={index}>
//                             <ListItem
//                               button
//                               key={items.title}
//                               component={Link}
//                               className={
//                                 localStorage.getItem("path") === items.path
//                                   ? "activeLink"
//                                   : ""
//                               }
//                               onClick={e => {
//                                 setSelectedIndex(items.path);
//                                 if (
//                                   localStorage.getItem("path") !== items.path
//                                 ) {
//                                   localStorage.setItem("path", items.path);
//                                   localStorage.setItem("rows", 10);
//                                 }
//                               }}
//                               to={`${items.path}`}
//                             >
//                               <ListItemText primary={items.title} />
//                             </ListItem>
//                           </span>
//                         </div>
//                       }
//                     </div>
//                   ))
//                 : localStorage.getItem("role") === "CAMPAIGNMANAGER"
//                 ? routeCampaign.map((items, index) => (
//                     <div key={index}>
//                       {
//                         <div
//                           key={index}
//                           className={
//                             props.sidebarRoute === items.path
//                               ? "sidebarColor menuItem"
//                               : "menuItem"
//                           }
//                         >
//                           <span key={index}>
//                             <ListItem
//                               button
//                               key={items.title}
//                               component={Link}
//                               className={
//                                 localStorage.getItem("path") === items.path
//                                   ? "activeLink"
//                                   : ""
//                               }
//                               onClick={e => {
//                                 setSelectedIndex(items.path);
//                                 if (
//                                   localStorage.getItem("path") !== items.path
//                                 ) {
//                                   localStorage.setItem("path", items.path);
//                                   localStorage.setItem("rows", 10);
//                                 }
//                               }}
//                               to={`${items.path}`}
//                             >
//                               <ListItemText primary={items.title} />
//                             </ListItem>
//                           </span>
//                         </div>
//                       }
//                     </div>
//                   ))
//                 : localStorage.getItem("role") === "ADMIN"
//                 ? routeAdmin.map((items, index) => (
//                     <div key={index}>
//                       {
//                         <div
//                           key={index}
//                           className={
//                             props.sidebarRoute === items.path
//                               ? "sidebarColor menuItem"
//                               : "menuItem"
//                           }
//                         >
//                           <span key={index}>
//                             <ListItem
//                               button
//                               key={items.title}
//                               component={Link}
//                               className={
//                                 localStorage.getItem("path") === items.path
//                                   ? "activeLink"
//                                   : ""
//                               }
//                               onClick={e => {
//                                 setSelectedIndex(items.path);
//                                 if (
//                                   localStorage.getItem("path") !== items.path
//                                 ) {
//                                   localStorage.setItem("path", items.path);
//                                   localStorage.setItem("rows", 10);
//                                 }
//                               }}
//                               to={`${items.path}`}
//                             >
//                               <ListItemText primary={items.title} />
//                             </ListItem>
//                           </span>
//                         </div>
//                       }
//                     </div>
//                   ))
//                 : ""}
//             </List>
//             <ul>
    
//             <li>
//               <div className="moreVertIconAndAvatar">
//                 <IconButton
                 
//                   aria-label="account of current user"
//                   aria-controls="menu-appbar"
//                   aria-haspopup="true"
//                   onClick={handleProfileMenuOpen}
//                   style={{ color: "#004a87" }}
//                 >
//                   {localStorage.getItem("profileImage") !== "null" && (
//                     <img
//                       style={{ width: "26px", borderRadius: "50%" }}
//                       src={
//                         getProfileImageUrl.url +
//                         localStorage.getItem("profileImage")
//                       }
//                     />
//                   )}
//                   {localStorage.getItem("profileImage") === "null" && (
//                     <div> {localStorage.getItem("name").substring(0, 1)} </div>
//                   )}

//                 </IconButton>
//               </div>
//               {renderMenu}
//               {renderPdf}
//             </li>
//             <li class="sideBarMenu" id="sideBarMenu">
//               <button><span></span></button>
//             </li>
//             </ul>
//           </div>
//         </AppBar>
//         {/*****************Footer for Sidebar******************* */}
//         {/***********************End**************************** */}
//         <div className="mainSectionBox">
//           <div className="mainSection">
     
//             <Switch>
//               {localStorage.getItem("role") === "ADMIN"
//                 ? routeAdmin.map((route, index) => (
//                     <Route
//                       key={index}
//                       path={route.path}
//                       exact={route.exact}
//                       component={route.main}
//                     />
//                   ))
//                 : localStorage.getItem("role") === "CUSTOMER"
//                 ? routeCustomer.map((route, index) => (
//                     <Route
//                       key={index}
//                       path={route.path}
//                       exact={route.exact}
//                       component={route.main}
//                     />
//                   ))
//                 : localStorage.getItem("role") === "SADMIN"
//                 ? routeConfig.map((route, index) => (
             
//                     <Route
//                       key={index}
//                       path={route.path}
//                       exact={route.exact}
//                       component={route.main}
//                     />
//                   ))
//                 : localStorage.getItem("role") === "CAMPAIGNMANAGER"
//                 ? routeCampaign.map((route, index) => (
//                     <Route
//                       key={index}
//                       path={route.path}
//                       exact={route.exact}
//                       component={route.main}
//                     />
//                   ))
//                 : ""}
//             </Switch>
//           </div>
//           <footer style={footerStyle}>
//             <div className="footerBox">
//               <h5>&copy; Xseller, 2021. All right reserved</h5>
//             </div>
//           </footer>
//         </div>
//         <div>
//           <Drawer anchor="right" open={state.right1}>
//             <ChangePassword
//               query={changePassword}
//               title="Change Password"
//               formConfig={addPasswordForm}
//               modalClose={toggleDrawer("right1", false)}
//               className={"ChangePassword"}
//               buttonName={"Update"}
//               message="Password updated successfully"
//               formValidation={changePasswordValidation}
//             />
//           </Drawer>
//         </div>
//         <div>
//           <Drawer anchor="right" open={state.right}>
//             <EditProfile
//               title="Edit Profile"
//               formConfig={editProfile}
//               modalClose={toggleDrawer("right", false)}
//               className={"EditProfile"}
//               editableData={state.name}
//               query={updateUser}
//               formValidation={editUsersValidation}
//               message="Profile updated successfully"
//               buttonName={"Update"}
//             />
//           </Drawer>
//         </div>
//       </div>
//     </Router>
//   );
// }

// const mapDispatchToProps = dispatch => {
//   return {
//     showDialogbox: data => dispatch({ type: "ShowModal", showModal: data }),
//     TimeDelay: data => dispatch({ type: "TimeDelay", seconds: data })
//   };
// };


// const mapStateToProps = state => {
//   return {
//     Header: state.Header,
//     userName: state.userName
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(MiniDrawer);
